import { defineComponent } from "vue"
import uuid from "../utils/uuid"

export default defineComponent({
  computed: {
    component_id: () => `cmp-${uuid()}`,
  },
})
